import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Calendar } from "lucide-react";
import { BRAND } from "../data/landing";
import { trackCTA } from "../lib/analytics";

const CTA_MOTION = {
  initial: { opacity: 0, y: 24, scale: 0.92 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: 24, scale: 0.92 },
  transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] },
};

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      // Show once past the hero (~700px) and hide near the contact form footer.
      const y = window.scrollY;
      const contact = document.getElementById("contact");
      const contactTop = contact ? contact.getBoundingClientRect().top + y : Infinity;
      const beyondHero = y > 700;
      const beforeContact = y + window.innerHeight < contactTop + 200;
      setVisible(beyondHero && beforeContact);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only globals (window/document) + state setter used; nothing reactive to track
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={BRAND.bookMeetingUrl}
          target="_blank"
          rel="noopener noreferrer"
          {...CTA_MOTION}
          onClick={() => trackCTA("Book a Meeting", "sticky")}
          className="hidden md:inline-flex fixed bottom-6 right-6 z-40 items-center gap-2.5 bg-[#1440E1] hover:bg-[#1033B3] text-white text-sm font-bold pl-5 pr-6 py-3.5 rounded-full shadow-[0_18px_40px_-12px_rgba(20,64,225,0.65)] tracking-wide transition-colors group"
          style={{ marginBottom: "44px" }}
          data-testid="sticky-book-meeting-cta"
        >
          <span className="size-7 rounded-full bg-white/15 flex items-center justify-center group-hover:rotate-12 transition-transform">
            <Calendar size={14} strokeWidth={2.25} />
          </span>
          Book a Meeting
        </motion.a>
      )}
    </AnimatePresence>
  );
}
